import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { Row, List, Typography, InputNumber, message } from 'antd';
import Button from '@mui/material/Button';
import debounce from 'lodash.debounce';

const PercentageAllocator = ({ items, onFinish }) => {
    const [percentages, setPercentages] = useState({});
    const [normalizedPercentages, setNormalizedPercentages] = useState({});
    const isInitialized = useRef(false);

    useEffect(() => {
        if (!isInitialized.current) {
            const initialPercentages = items.reduce((acc, item) => {
                acc[item.key] = 0;
                return acc;
            }, {});
            setPercentages(initialPercentages);
            isInitialized.current = true;
        }
    }, [items]);

    const handlePercentageChange = (key, value) => {
        setPercentages(prevPercentages => ({
            ...prevPercentages,
            [key]: value
        }));
    };

    const normalizePercentages = () => {
        const total = Object.values(percentages).reduce((acc, value) => acc + value, 0);
        if (total === 0) {
            message.error('Total percentage must be greater than zero');
            return;
        }
        const normalizedPercentages = Object.keys(percentages).reduce((acc, key) => {
            acc[key] = (percentages[key] / total) * 100;
            return acc;
        }, {});
        setNormalizedPercentages(normalizedPercentages);
    };

    const debouncedNormalize = useRef(debounce(normalizePercentages, 300)).current;

    useEffect(() => {
        debouncedNormalize();
    }, [percentages, debouncedNormalize]);

    return (
        <>
            <Row>
                <Button variant={'contained'} color={'info'} onClick={()=>onFinish(percentages)}>FINISH</Button>
            </Row>
            <List
                dataSource={items}
                renderItem={(item) => (
                    <List.Item key={item.key}>
                        <Typography.Text>{item.name}</Typography.Text>
                        <InputNumber
                            min={0}
                            max={100}
                            value={percentages[item.key]}
                            onChange={(value) => handlePercentageChange(item.key, value)}
                            placeholder="%"
                            style={{ marginLeft: '10px' }}
                        />
                    </List.Item>
                )}
            />
        </>
    );
};

PercentageAllocator.propTypes = {
    items: PropTypes.arrayOf(PropTypes.shape({
        key: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
    })).isRequired,
    onFinish: PropTypes.func.isRequired,
};

export default PercentageAllocator;
